import { AgeCategoryLabel as BaseAgeCategoryLabel } from '@mews/business-components';
import { connect } from './connect';

export const AgeCategoryLabel = connect(BaseAgeCategoryLabel);
